import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'mmx-app-loader',
  templateUrl: './app-loader.component.html',
  styleUrls: ['./app-loader.component.scss'],
  standalone: false,
})
export class AppLoaderComponent {
  title
  message
  constructor(public dialogRef: MatDialogRef<AppLoaderComponent>) {}
}
